/*
 * Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
 * See LICENSE in the project root for license information.
 */

/* global console, document, Excel, Office */

// executes when the office application is loaded;
// it is now safe to make API calls
Office.onReady(async (info) => {
  if (info.host === Office.HostType.Excel) {
    //await Excel.run(async (context) => {
    //  const activeWorksheet = context.workbook.worksheets.getActiveWorksheet();
    //  activeWorksheet.onSingleClicked.add(handleSingleClicked);
    //  await context.sync();
    //});
    document.getElementById("txtKeyWord1").onkeyup = () => tryCatch(filterData);
    document.getElementById("txtKeyWord2").onkeyup = () => tryCatch(filterData);
    document.getElementById("optAndOr").onchange = () => tryCatch(filterData);
    //document.getElementById("btnFilter").onclick = () => tryCatch(filterData);
    document.getElementById("btnClearKeywords").onclick = () => tryCatch(clearKeywords);
    document.getElementById("sideload-msg").style.display = "none";
    document.getElementById("app-body").style.display = "flex";
    filterData();
  }
});

//async function register_onSingleClickedHandler() {
//  await Excel.run(async (context) => {
//    const activeWorksheet = context.workbook.worksheets.getActiveWorksheet();
//    activeWorksheet.onSingleClicked.add(handleSingleClicked);
//    await context.sync();
//  });
//}

//async function handleSingleClicked(event) {
//  return Excel.run(async function (context) {
//    await context.sync();
//    console.log("Change type of event: " + event.changeType);
//    console.log("Address of event: " + event.address);
//    console.log("Source of event: " + event.source);
//  });
//}

// display a message on taskpane.html
function displayMessage(messageToDisplay) {
  document.getElementById("lblMessage").innerHTML = messageToDisplay;
}

// clear button was clicked
async function clearKeywords() {
  document.getElementById("txtKeyWord1").value = "";
  //document.getElementById("optAndOr").value = "";
  document.getElementById("txtKeyWord2").value = "";
  await filterData();
}

// get the filename that is being worked on
async function getCurrentFileName() {
  return new Promise((resolve) => {
    Office.context.document.getFilePropertiesAsync(null, (res) => {
      if (res && res.value && res.value.url) {
        let name = res.value.url.substring(res.value.url.lastIndexOf("/") + 1);
        resolve(name);
      }
      resolve("");
    });
  });
}

// filter data
async function filterData() {
  await Excel.run(async (context) => {
    const keyword1Value = document.getElementById("txtKeyWord1").value;
    const optAndOrValue = document.getElementById("optAndOr").value;
    const keyword2Value = document.getElementById("txtKeyWord2").value;
    const andValue = "And";
    const orValue = "Or";
    const currentFileName = await getCurrentFileName();
    const supportedWorksheets = [
      { fileName: "WTMDP&ID.xlsm", dataSheetName: "TUNNEL", range: "a5:K1000", filterField: 10 },
      { fileName: "WTDWGLIST.xlsm", dataSheetName: "TUNNEL", range: "a4:p5000", filterField: 15 },
      { fileName: "VBDWGLIST.xlsm", dataSheetName: "VINCE BAYOU", range: "a5:P5000", filterField: 15 },
      { fileName: "FADwgList.xlsm", dataSheetName: "40-ACRE", range: "a6:P5000", filterField: 15 },
      { fileName: "CODWGLIST.xlsm", dataSheetName: "CENTRAL OFFICE", range: "a4:P5000", filterField: 15 },
      { fileName: "CLDWGLIST.xlsm", dataSheetName: "CENTRAL LAB", range: "a5:P5000", filterField: 15 },
      { fileName: "BPMDP&IDLIST.xlsm", dataSheetName: "BAYPORT", range: "a3:J1000", filterField: 9 },
      { fileName: "BPMDFOLIST.xlsm", dataSheetName: "BAYPORT", range: "a3:J1000", filterField: 9 },
      { fileName: "BPMDEOLIST.xlsm", dataSheetName: "BAYPORT", range: "a3:J1000", filterField: 9 },
      { fileName: "BPDWGLIST.xlsm", dataSheetName: "BAYPORT", range: "a4:P5000", filterField: 15 },
      { fileName: "BHMDDWGList.xlsm", dataSheetName: "BLACKHAWK", range: "a3:P3000", filterField: 15 },
      { fileName: "BHDWGLIST.xlsm", dataSheetName: "ARCHIVES", range: "a3:P3000", filterField: 15 },
    ];

    // find the worksheet in supportedWorksheets array
    const supportedWorksheet = supportedWorksheets.find((i) => i.fileName === currentFileName);

    // is this spreadsheet defined in supportedWorksheets array
    if (supportedWorksheet) {
      const activeWorksheet = context.workbook.worksheets.getActiveWorksheet();
      activeWorksheet.autoFilter.remove();

      // have 2 key values with And
      if (keyword1Value && keyword2Value && optAndOrValue == andValue) {
        activeWorksheet.autoFilter.apply(supportedWorksheet.range, supportedWorksheet.filterField, {
          filterOn: Excel.FilterOn.custom,
          operator: Excel.FilterOperator.and,
          criterion1: "=*" + keyword1Value + "*",
          criterion2: "=*" + keyword2Value + "*",
        });
        // 2 key values with Or
      } else if (keyword1Value && keyword2Value && optAndOrValue == orValue) {
        activeWorksheet.autoFilter.apply(supportedWorksheet.range, supportedWorksheet.filterField, {
          filterOn: Excel.FilterOn.custom,
          operator: Excel.FilterOperator.or,
          criterion1: "=*" + keyword1Value + "*",
          criterion2: "=*" + keyword2Value + "*",
        });
        // First Keyword only
      } else if (keyword1Value) {
        activeWorksheet.autoFilter.apply(supportedWorksheet.range, supportedWorksheet.filterField, {
          filterOn: Excel.FilterOn.custom,
          criterion1: "=*" + keyword1Value + "*",
        });
        // Second Keyword only
      } else if (keyword2Value) {
        activeWorksheet.autoFilter.apply(supportedWorksheet.range, supportedWorksheet.filterField, {
          filterOn: Excel.FilterOn.custom,
          criterion1: "=*" + keyword2Value + "*",
        });
      }
      // The spreadsheet is not defined in supportedWorksheets array
    } else {
      displayMessage("Filename " + currentFileName + " is not defined/supported in this Add-In.");
    }

    await context.sync();
  });
}

// default helper for invoking an action and handling errors.
async function tryCatch(callback) {
  try {
    await callback();
  } catch (error) {
    displayMessage("Error detected: " + error);
  }
}
